import { IconPlaceholderImages24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

export const OfferGalleryEmpty: React.VFC = () => {
  return (
    <div className={styles['image']}>
      <IconPlaceholderImages24 color="surface-neutral-pressed" display="block" />
    </div>
  );
};
